import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class UserReferenceService extends BaseReferenceService {
  constructor() {
    super('UserReference');
  }
}
